module.exports = __webpack_public_path__ + "static/media/icon-bird.7757723f.svg";